import { useAuth0 } from '@auth0/auth0-react';
import { IconButton, TableContainer } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Avatar from '@mui/material/Avatar';
import Popover from '@mui/material/Popover';
import { ReactComponent as PlusIcon } from "assets/icons/plus.svg";
import sortImg from 'assets/icons/sort-able-svg.svg';
import user from 'assets/icons/user.jpg';
import Button from 'components/button/Button';
import Loader from 'components/loader/Loader';
import PastoralService from 'Lib/API/PastoralApi/index';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import ImageUploader from 'react-images-upload';
import { toastr } from 'react-redux-toastr';
import Action from '../../../components/ActionPopOver';
import AlertDialog from '../../../components/Dialog';
import RightDrawer from '../../../components/drawer';
import MyButton from '../../../components/MyButton';
import MyModal from '../../../components/MyModal';
import SearchComp from '../../../components/Searchcomponent';
import UserService from '../../../Lib/API/users';
import Service from '../../../Lib/service';
import AddUserDrawer from './addUserDrawer/AddUserDrawer';
import ResetMobilePasswordModal from './ResetMobilePassword/ResetMobilePasswordModal';
import './style.scss';
import UpdateUserDrawer from './updateUserDrawer/UpdateUserDrawer';
import UserDrawer from './userDrawer/UserDrawer';

const TableCellHead = withStyles((theme) => ({
  root: {
    height: '46px',
    padding: '0px 40px',
    borderBottom: 'none',
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: '61px',
    padding: '0px 40px',
  },
}))(TableCell);

const initialFilters = {
   role: 1, name: 1, email: 1, last_active: 1,
};

const Users = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [openShabbat, setOpenShabbat] = useState(false);
  const [openVacation, setOpenVacation] = useState(false);
  const [isAddUserDrawerOpen, setIsAddUserDrawerOpen] = useState(false);
  const [isUpdateUserDrawerOpen, setIsUpdateUserDrawerOpen] = useState(false);
  const [updateUserRow, setUpdateUserRow] = useState(null);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [userList, setUserList] = useState([]);
  const [triggerUploadImg, setTriggerUploadImg] = useState(false);
  const [profileImage, setProfileImage] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [openAlertDelete, setOpenAlertDelete] = useState(false);
  const [deleteHandle, setDeleteHandle] = useState(false);
  const [openAlertBlock, setOpenAlertBlock] = useState(false);
  const [blockHandle, setblockHandle] = useState(false);
  const [userId, setUserId] = useState('');
  const [blockedRow, setBlockedRow] = useState({});
  const [listModules, setListModules] = useState([]);
  const [loadingModule, setLoadingModule] = useState(false);
  const [pictures, setPictures] = useState();
  const [usersData, setUsersData] = useState([]);
  const [eventUserLoading, setEventUserLoading] = useState(false);
  const [openMobileResetPassword, setOpenMobileResetPassword] = useState(false);
  const [generateNewPasswordLoading, setGenerateNewPasswordLoading] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  const [selectedUserData, setSelectedUserData] = useState({});
  
  const [userData, setUserData] = useState({
    first_name: '',
    last_name: '',
    role: '',
    email: '',
    profile_img: '',
    authorizedModules: [],
  });
  const [sort, setSort] = useState(initialFilters);
  const [searchValue, setSearchValue] = useState('');
  

  const openPopOver = (e) => {
    setAnchorEl(e.currentTarget);
  };
  
  const fetchMyAPI = async (e) => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    const payload = {
      sort: sort,
      ...(searchValue ? { search: searchValue } : {}),
    }
    await UserService.getAllUsers(token, page + 1, 30, payload).then((res) => {
      const result = res?.payload?.data;
      setUserList(result);
      setCount(res?.payload?.pagination?.count);
      setLoading(false);
    });
  };

  const getUsersHandler = async () => {
    setEventUserLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventUsers({ token, page: 1 })
      .then((res) => {
        if (res) {
          const formattedUsers = res?.users.map((item) => ({ 
            label: `${item?.type} ${item?.fullName ? "- " + item?.fullName : ""}`,
            value: item?.id 
          }));
          setUsersData(formattedUsers);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setEventUserLoading(false);
      });
  };

  const debounceSearch = useCallback(
    debounce(() => {
      if (searchValue) {
        fetchMyAPI();
      }
    }, 1000),
    [searchValue,sort, page, refresh]
  );

  useEffect(() => {
    if (searchValue) {
      debounceSearch();
    } else {
      fetchMyAPI();
    }
    return () => debounceSearch.cancel();
  }, [page, refresh, sort,searchValue]);

  useEffect(() => {
    getUsersHandler();
    getAuthorizedModules();
  }, []);

  const getAuthorizedModules = async () => {
    setLoadingModule(true);
    const token = await getAccessTokenSilently();
    await UserService.authorizedModules(token).then((res) => {
      setListModules(res.result);
      setLoadingModule(false);
    });
  };

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }
  const handleChange = async (e) => {
    if (e.target.files.length) {
      let imageDataUrl = await readFile(e.target.files[0]);
      setProfileImage(imageDataUrl);
      // setTimeout(() => {
      //   setOpenCropper(true);
      // }, 1000);
    }
  };

  const onDrop = async (pictureFiles, pictureDataURLs) => {
    setPictures(pictureFiles);
    let imageDataUrl = await readFile(pictureFiles[0]);
    setProfileImage(imageDataUrl);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const deleteUser = async (id) => {
    const token = await getAccessTokenSilently();
    handleClose();
    try {
      const response = await UserService.deleteUser(id, token);
      setRefresh(!refresh);
      toastr.success('User Deleted Successfuly!');
    } catch (error) {
      console.log(error);
      toastr.error(error?.data?.message);
    }
    setOpenAlertDelete(false);
    setDeleteHandle(false);
    setUserId('');
    isDrawerOpen && setIsDrawerOpen(false);
  };

  const blockUser = async (id) => {
    const token = await getAccessTokenSilently();
    handleClose();
    try {
      const response = await UserService.blockUser(token, {
        userId: id,
        // contactId: blockedRow?.contactId,
        // first_name: blockedRow?.name?.split(' ')[0],
        // last_name: blockedRow?.name?.slice(
        //   blockedRow?.name?.split(' ')[0].length + 1
        // ),
        // role: blockedRow?.role,
        blockStatus: blockedRow?.active === true ? true : false,
        // authorizedModules: blockedRow?.authorizedModules
        //   ?.filter((item) => item.active === true)
        //   .map((item) => ({
        //     moduleName: item.moduleName,
        //     active: item.active,
        //   })),
        // authorizedModules: row?.authorizedModules?.map(item => item.active ===false ),
        // authorizedModules: row?.authorizedModules?.map(item => item.active ===false ? item.moduleName : null).filter(item => item !== null ),
      });
      setRefresh(!refresh);
      toastr.success(`${blockedRow?.active === true ? 'User Blocked Successfuly!' : 'User Enabled Successfuly!'}`);
    } catch (error) {
      console.log(error);
      toastr.error(error.data.message);
    }
    setOpenAlertBlock(false);
    setblockHandle(false);
    setUserId('');
    isDrawerOpen && setIsDrawerOpen(false);
  };

  useEffect(() => {
    if (deleteHandle && userId) {
      deleteUser(userId);
    }
  }, [deleteHandle]);

  useEffect(() => {
    if (blockHandle && userId) {
      blockUser(userId);
    }
  }, [blockHandle]);

  const handleSorting = (name) => {
    setSort((prev) => ({
      ...prev,
      [name]: prev[name] === 1 ? -1 : 1,
    }));
  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setPage(0);
  }

  const generateNewPassword= async () => {
    const token = await getAccessTokenSilently();
    setGenerateNewPasswordLoading(true);
    const payload = {
      contactId: selectedUserData?.type === "add" ? selectedUserData?.contactId : updateUserRow?.contactId,
    }
    await PastoralService.generateNewPassword({token, data:payload})
    .then((response) => {
      toastr.success("Success", "Password has been generated successfully");
      setOpenMobileResetPassword(false);
      if(selectedUserData?.type === "add") {
        setIsAddUserDrawerOpen(false);
        setIsUpdateUserDrawerOpen(false);
      }
    })
    .catch((error) => {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    })
    .finally(() => {
      setGenerateNewPasswordLoading(false);
    });
  }


  const openMobileResetPasswordHandler = (type,contactId) => {
    setOpenMobileResetPassword(true);
    setSelectedUserData({type,contactId});
  }
  const closeMobileResetPasswordHandler = () => {
    setOpenMobileResetPassword(false);
    setIsAddUserDrawerOpen(false);
  }


  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setIsAddUserDrawerOpen(false);
    setIsUpdateUserDrawerOpen(false);
    setOpenShabbat(false);
    setOpenVacation(false);
    setProfileImage("");
  }

  const closeAddUserDrawer = () => {
    setIsAddUserDrawerOpen(false);
    setProfileImage("");
  }

  const closeUpdateUserDrawer = () => {
    setIsUpdateUserDrawerOpen(false);
    setProfileImage("");
  }


  return (
    <>
      <div className="user__setting__container">
        <div className="user__table__header user-settings-types-setting-page">
          <div className="left__setction">
            <div className="search__bar">
              <SearchComp 
                style={{ width: "20.5rem", backgroundColor: "#fff" }}
                setSearchText={handleSearch}
                placeholder="Search"
              />
            </div>
          </div>
          <div className="right__section">
            <Button
              variant='primary'
              onClick={() => setIsAddUserDrawerOpen(true)}
              style={{ marginLeft: 10}}
              size="md"
            >
              <PlusIcon />
              <span>New User</span>
            </Button>
          </div>
        </div>
        <div className="user__table__container">
          <TableContainer className="mt-5 scroll-table">
            <Table aria-label="simple table">
              <TableRow className="table__header__row sticky-table-header">
                <TableCellHead
                  className="header__cell user__role__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">
                    ROLE
                    <IconButton onClick={() => handleSorting("role")}>
                      <img src={sortImg} alt="sort" />
                    </IconButton>
                  </span>
                </TableCellHead>
                <TableCellHead
                  className="header__cell user__name__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">
                    NAME
                    <IconButton onClick={() => handleSorting("name")}>
                      <img src={sortImg} alt="sort" />
                    </IconButton>
                  </span>
                </TableCellHead>
                <TableCellHead
                  className="header__cell user__email__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">
                    Email{' '}
                    <IconButton onClick={() => handleSorting("email")}>
                      <img src={sortImg} alt="sort" />
                    </IconButton>
                  </span>
                </TableCellHead>
                <TableCellHead
                  className="header__cell user__lastActive__cellHeader"
                  align="left"
                >
                  <span
                    className="d-flex align-items-center"
                    style={{ width: '120px' }}
                  >
                    LAST ACTIVE{' '}
                    <IconButton onClick={() => handleSorting("last_active")}>
                      <img src={sortImg} alt="sort" />
                    </IconButton>
                  </span>
                </TableCellHead>
                {loadingModule ? (
                  <TableCellHead rowSpan={listModules.length} align="center" className='header__cell'>
                    loading ...
                  </TableCellHead>
                ) : listModules.length === 0 ? (
                  ''
                ) : (
                  listModules.map((item) => {
                    return (
                      <TableCellHead
                        className="header__cell user__member__cell"
                        align="left"
                      >
                        <span className="d-flex align-items-center" style={{whiteSpace: "nowrap"}}>
                          {item.moduleName.toUpperCase()}{' '}
                        </span>
                      </TableCellHead>
                    );
                  })
                )}
                {/* <TableCellHead
                  className="header__cell user__member__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">MEMBERS </span>
                </TableCellHead>
                <TableCellHead
                  className="header__cell user__financial__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">FINANCIAL </span>
                </TableCellHead>
                <TableCellHead
                  className="header__cell user__events__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">EVENTS </span>
                </TableCellHead>
                <TableCellHead
                  className="header__cell user__education__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">EDUCATION</span>
                </TableCellHead>
                <TableCellHead
                  className="header__cell user__postoral__cell"
                  align="left"
                >
                  <span className="d-flex align-items-center">POSTORAL</span>
                </TableCellHead> */}
                <TableCellHead 
                  className="header__cell__action sticky-header-column" 
                  align="left" 
                   style={{
                    padding: '16px',
                  }}
                >
                  {/* <MoreHorizIcon color="primary" className="more__hor" /> */}
                </TableCellHead>
              </TableRow>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div className="user__loader">
                        <Loader />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : userList?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div
                        style={{
                          paddingBlock: '20px',
                          textAlign: 'center',
                          height: '500px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        No record found
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  userList?.map((row) => (
                    <tr key={row?._id} className="user_table_row">
                      <TableCellBody
                        className="table__body__cell user__role__cell"
                        align="left"
                        onClick={() => {
                          setDrawerData(row);
                          setIsDrawerOpen(true);
                        }}
                      >
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {row?.role}
                        </span>
                      </TableCellBody>
                      <TableCellBody
                        className="table__body__cell user__name__cell"
                        align="left"
                        onClick={() => {
                          setDrawerData(row);
                          setIsDrawerOpen(true);
                        }}
                      >
                        <div className="name__user__feild d-flex align-items-center">
                          {row?.profile_img ? (
                            <img
                              src={row?.profile_img}
                              style={{
                                width: '31px',
                                height: '31px',
                                borderRadius: '50%',
                              }}
                              alt="user"
                            />
                          ) : (
                            <Avatar sx={{ width: '31px', height: '31px' }}>
                              {row?.name?.substring(0, 2)}
                            </Avatar>
                          )}
                          <span
                            className="ml-3"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            {row?.name}
                          </span>
                        </div>
                      </TableCellBody>
                      <TableCellBody
                        className="table__body__cell user__email__cell"
                        align="left"
                        onClick={() => {
                          setDrawerData(row);
                          setIsDrawerOpen(true);
                        }}
                      >
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {row?.email}
                        </span>
                      </TableCellBody>
                      <TableCellBody
                        className="table__body__cell user__lastActive__cell"
                        align="left"
                        onClick={() => {
                          setDrawerData(row);
                          setIsDrawerOpen(true);
                        }}
                      >
                        {row?.last_active
                          ? moment(row?.last_active).utcOffset('+0100').format('MM/DD/YYYY')
                          : ' - '}
                      </TableCellBody>
                      {listModules?.map((mod) => {
                        // eslint-disable-next-line no-unused-expressions
                        if (
                          row?.authorizedModules?.find(
                            (item) => item?.moduleName === mod?.moduleName
                          )?.active === true
                        ) {
                          return (
                            <TableCellBody
                              className="table__body__cell user__member__cell"
                              align="left"
                              onClick={() => {
                                setDrawerData(row);
                                setIsDrawerOpen(true);
                              }}
                            >
                              <span className='admin_role'>Admin</span>
                            </TableCellBody>
                          );
                        } else {
                          return (
                            <TableCellBody
                              className="table__body__cell user__member__cell"
                              align="left"
                              onClick={() => {
                                setDrawerData(row);
                                setIsDrawerOpen(true);
                              }}
                            >
                              <span className='disabled_role'>Disabled</span>
                            </TableCellBody>
                          );
                        }
                      })}

                       {/* <TableCellBody
                        className="table__body__cell user__financial__cell"
                        align="left"
                        onClick={() => {
                          setDrawerData(row);
                          setIsDrawerOpen(true);
                        }}
                      >
                        <span
                          className={
                            row?.authorizedModules?.find(
                              (item) => item?.moduleName === 'finance'
                            )
                              ? row?.authorizedModules?.find(
                                  (item) => item?.moduleName === 'finance'
                                )?.active === true
                                ? 'admin_role'
                                : 'disabled_role'
                              : 'disabled_role'
                          }
                        >
                          {row?.authorizedModules?.find(
                            (item) => item?.moduleName === 'finance'
                          )
                            ? row?.authorizedModules?.find(
                                (item) => item?.moduleName === 'finance'
                              )?.active === true
                              ? 'Admin'
                              : 'Disabled'
                            : 'Disabled'}
                        </span>
                      </TableCellBody> */}

                      <TableCellBody
                        className="table__body__cell__action sticky-body-column"
                        align="left"
                        style={{
                          padding: '16px',
                        }}
                      >
                        <IconButton className="p-0 px-2">
                          <Action
                            onEditClick={() => {
                              setUpdateUserRow(row);
                              setIsUpdateUserDrawerOpen(true);
                              setAnchorEl(null);
                            }}
                            // onActiveClick={() => {}}
                            onDeleteClick={() => {}}
                            style={{
                              width: '16px',
                              height: '16px',
                            }}
                            // checkActive={true}
                            action={'userAction'}
                            setUpdateUserRow={setUpdateUserRow}
                            setIsUpdateUserDrawerOpen={
                              setIsUpdateUserDrawerOpen
                            }
                            row={row}
                            setRefresh={setRefresh}
                            refresh={refresh}
                            setOpenAlertDelete={setOpenAlertDelete}
                            setDeleteHandle={setDeleteHandle}
                            deleteHandle={deleteHandle}
                            setOpenAlertBlock={setOpenAlertBlock}
                            setblockHandle={setblockHandle}
                            blockHandle={blockHandle}
                            setUserId={setUserId}
                            userId={userId}
                            setBlockedRow={setBlockedRow}
                            activeUesr={row?.active}
                          />
                        </IconButton>
                      </TableCellBody>
                    </tr>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <RightDrawer
            open={isDrawerOpen}
            onClose={() => {
              setIsDrawerOpen(false);
              setOpenShabbat(false);
              setOpenVacation(false);
            }}
            drawerData={drawerData}
          >
            <UserDrawer
              drawerData={drawerData}
              setOpenShabbat={setOpenShabbat}
              openShabbat={openShabbat}
              setOpenVacation={setOpenVacation}
              openVacation={openVacation}
              setUpdateUserRow={setUpdateUserRow}
              setIsUpdateUserDrawerOpen={setIsUpdateUserDrawerOpen}
              setAnchorEl={setAnchorEl}
              setRefresh={setRefresh}
              refresh={refresh}
              setOpenAlertDelete={setOpenAlertDelete}
              setDeleteHandle={setDeleteHandle}
              deleteHandle={deleteHandle}
              setOpenAlertBlock={setOpenAlertBlock}
              setblockHandle={setblockHandle}
              blockHandle={blockHandle}
              setUserId={setUserId}
              userId={userId}
              setBlockedRow={setBlockedRow}
              usersData={usersData}
              eventUserLoading={eventUserLoading}
            />
          </RightDrawer>

          {/* drawer for add new user */}
          <RightDrawer
            open={isAddUserDrawerOpen}
            onClose={closeModal}
          >
            <AddUserDrawer
              isAddUserDrawerOpen={isAddUserDrawerOpen}
              closeModal={closeModal}
              handleClose={closeAddUserDrawer}
              setOpenShabbat={setOpenShabbat}
              openShabbat={openShabbat}
              setOpenVacation={setOpenVacation}
              openVacation={openVacation}
              setTriggerUploadImg={setTriggerUploadImg}
              triggerUploadImg={triggerUploadImg}
              setProfileImage={setProfileImage}
              profileImage={profileImage}
              setUserData={setUserData}
              userData={userData}
              setRefresh={setRefresh}
              refresh={refresh}
              pictures={pictures}
              openMobileResetPassword={openMobileResetPasswordHandler}

            />
          </RightDrawer>

          {/* drawer for update user */}
          <RightDrawer
            open={isUpdateUserDrawerOpen}
            onClose={closeModal}
          >
            <UpdateUserDrawer
              isUpdateUserDrawerOpen={isUpdateUserDrawerOpen}
              closeModal={closeModal}
              handleClose={closeUpdateUserDrawer}
              setOpenShabbat={setOpenShabbat}
              openShabbat={openShabbat}
              setOpenVacation={setOpenVacation}
              openVacation={openVacation}
              updateUserRow={updateUserRow}
              setTriggerUploadImg={setTriggerUploadImg}
              triggerUploadImg={triggerUploadImg}
              profileImage={profileImage}
              setProfileImage={setProfileImage}
              setRefresh={setRefresh}
              refresh={refresh}
              setIsDrawerOpen={setIsDrawerOpen}
              pictures={pictures}
              openMobileResetPassword={openMobileResetPasswordHandler}
            />
          </RightDrawer>
        </div>
        <MyModal
					className="sendemail-modal"
					open={openMobileResetPassword}
					onClose={closeMobileResetPasswordHandler}
				>
					<ResetMobilePasswordModal 
              generateNewPassword={generateNewPassword}
              closeModal={closeMobileResetPasswordHandler} 
              isLoading={generateNewPasswordLoading}
            />
				</MyModal>
        <MyModal
          open={triggerUploadImg}
          onClose={() => {
            setProfileImage('');
            setTriggerUploadImg(false);
          }}
        >
          <div className="personal-info-image">
            <ImageUploader
              withIcon={false}
              withPreview={true}
              buttonText="Choose images"
              onChange={onDrop}
              accept=".png,.jpg,.jpeg"
              imgExtension={['.jpg', '.png']}
              maxFileSize={5242880}
            />
            <MyButton
              content={'Save'}
              onClick={() => setTriggerUploadImg(false)}
            />
          </div>
        </MyModal>
        <AlertDialog
          open={openAlertDelete}
          onDecline={() => {
            setOpenAlertDelete(false);
            setUserId('');
          }}
          onAccept={() => {
            setDeleteHandle(true);
          }}
          title={`Are you sure?`}
          description={"Do you want to delete this user?"}
        />
        <AlertDialog
          open={openAlertBlock}
          onDecline={() => {
            setOpenAlertBlock(false);
            setUserId('');
          }}
          onAccept={() => {
            setblockHandle(true);
          }}
          title="Are you sure?"
          description={`${blockedRow?.active === true ? "Do you want to disable this user?" : "Do you want to enable this user?"}`}
        />
      <div className="pagination-custom mt-5 pagination-scdeuled">
        <Pagination
          count={Math.ceil(count / 30)}
          color="primary"
          variant="outlined"
          onChange={(event, value) => {
            setPage(value - 1);
          }}
          page={page + 1}
        />
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
      </div>
    </>
  );
};

export default Users;
